module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.ready) ? _c('div', {}, [(_vm.authorized) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Logout from facebook')))]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Login from facebook')))]), _vm._v(" "), (_vm.authorized) ? _c('div', {}) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4300bb03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBLogin.vue
// module id = 304
// module chunks = 1